/**
 * Created by mykurisu on 2017/11/14.
 */
import React from 'react'
import qr from 'qr-encode'
import axios from 'axios'
import "../../css/page/ClassroomPage.css"
import close1 from '../../images/classroom/classroom_bottom_close_1.png'
import close2 from '../../images/classroom/classroom_bottom_close_2.png'
import img1 from '../../images/classroom/classroom_bottom_animation_1.png'
import img2 from '../../images/classroom/classroom_bottom_animation_2.png'


class ClassroomBottomAnimation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shouldShow: false,
            isBigScreen: false,
            enterTiming: 0,
            styleType: 0,
            qrcode: null,
        }
    }

    componentDidMount() {
        let width = document.body.clientWidth;
        if (width > 420){
            this.setState({
                isBigScreen: true
            })
        }

        /*setTimeout(() => {
            this.setState({
                qrcode: qr(this.props.qrcodes.lecture_qrcode),
                shouldShow: true
            })
        }, 10000)*/

        //wk-classroom-qrcode-shown  {id: '', date: ''}
        //wk-classroom-qrcode-shown-times 0 1 2

        let qrcodeShowTimes = window.localStorage.getItem('wk-classroom-qrcode-shown-times') || 0;
        let shownData_raw = window.localStorage.getItem('wk-classroom-qrcode-shown') || '';

        if (shownData_raw !== ''){
            let time = new Date();
            let shownData = JSON.parse(shownData_raw);
            if (qrcodeShowTimes === 2 && (Number(shownData.date) === time.getDate())){
                console.log('模式--同一天出现次数2');
                return true
            }

            if (Number(shownData.date) !== time.getDate()){
                console.log('模式--第二天，次数清零');

                window.localStorage.setItem('wk-classroom-qrcode-shown-times', 0);
                this.handleItShow(1);
                return true
            }

            if (qrcodeShowTimes < 2 && (Number(shownData.date) === time.getDate())){
                if (Number(shownData.id) === this.props.lecture.id){
                    console.log('模式--同一天，同一节课');

                    return true
                }
                console.log('模式--同一天，出现不为2');

                this.handleItShow(Number(qrcodeShowTimes) + 1);
                return true
            }
        }else {
            console.log('模式--未出现过');
            window.localStorage.setItem('wk-classroom-qrcode-shown-times', 0);
            this.handleItShow(1);
        }

    }

    handleItShow(qrcodeShowTimes) {
        let showTime = 480000;
        if (this.props.account.id === 6583){
            showTime = 6000;
        }
        let time = new Date();
        let timestamp = time.getTime();
        let date = time.getDate();
        this.setState({
            enterTiming: timestamp
        }, () => {
            this.timer = setInterval(() => {
                if ((Date.now() - this.state.enterTiming) >= (showTime - 80000)){
                    //请求二维码或者绘制二维码
                    if (!this.state.qrcode){
                        console.log('请求二维码');
                        axios.get('api/board/get_qrcode', {
                            params: {
                                object_id: this.props.lecture.id,
                                wtype: this.state.styleType === 0 ? 'classroom1' : 'classroom2'
                            }
                        })
                            .then(res => {
                                if (res.data.code === 0) {
                                    this.setState({
                                        qrcode: res.data.data.qrcode_content
                                    })
                                }
                            });
                    }
                }

                if ((Date.now() - this.state.enterTiming) > showTime){
                    console.log('显示动画');
                    this.setState({
                        shouldShow: true
                    }, () => {
                        let data = {
                            id: this.props.lecture.id,
                            date: date
                        };
                        window.localStorage.setItem('wk-classroom-qrcode-shown', JSON.stringify(data));
                        window.localStorage.setItem('wk-classroom-qrcode-shown-times', qrcodeShowTimes);
                        this.timer && clearInterval(this.timer);
                    })

                }
            }, 10000)
        })
    }

    componentWillUnmount() {
        this.timer && clearInterval(this.timer);
    }

    render(){

        if (!this.state.shouldShow){
            return null
        }

        return (
            <div className="classroom__bottom">
                <div className="bottom__animation">
                    <div className="animation__close" onClick={() => {
                        this.setState({
                            shouldShow: false
                        })
                    }}>
                        <img src={this.state.styleType === 0 ? close1 : close2} alt=""/>
                    </div>

                    <div className="animation__qrcode">
                        <img src={qr(this.state.qrcode)} alt=""/>
                    </div>

                    <div className={this.state.styleType === 0 ? 'animation__bg-type0' : 'animation__bg-type1'}>
                        <div className={this.state.isBigScreen ? 'bg__top-hack' : 'bg__top'}></div>
                        <div className={this.state.isBigScreen ? 'bg__bottom-hack' : 'bg__bottom'}></div>
                    </div>

                    <div className="animation__img">
                        <img src={this.state.styleType === 0 ? img1 : img2} alt=""/>
                    </div>

                    <p className="animation__text" style={{color: this.state.styleType === 0 ? '#F44336' : '#007DBE'}}>长按扫码关注后，赚钱听课两不误</p>
                </div>
            </div>
        )
    }
}

export default ClassroomBottomAnimation



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomBottomAnimation.js